/**
 * @generated SignedSource<<2a13b4db7c4b88111c27b435ef7cfa59>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type richTextField_issueViewLayoutRichTextField$data = {
  readonly description: string | null | undefined;
  readonly fieldId: string;
  readonly isEditableInIssueView: boolean | null | undefined;
  readonly name: string;
  readonly richText: {
    readonly adfValue: {
      readonly json: AGG$JSON | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"view_issueViewBase_DefaultMultilineField">;
  readonly " $fragmentType": "richTextField_issueViewLayoutRichTextField";
};
export type richTextField_issueViewLayoutRichTextField$key = {
  readonly " $data"?: richTextField_issueViewLayoutRichTextField$data;
  readonly " $fragmentSpreads": FragmentRefs<"richTextField_issueViewLayoutRichTextField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "richTextField_issueViewLayoutRichTextField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "isEditableInIssueView"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "json"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "view_issueViewBase_DefaultMultilineField"
    }
  ],
  "type": "JiraRichTextField"
};

(node as any).hash = "7bca40f9a197c3bb952b57c902d4ff57";

export default node;
